function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "aw"
}, React.createElement("path", {
  d: "M12,17.25a10.59,10.59,0,0,1-3.15-.49.5.5,0,0,1,.29-1,10,10,0,0,0,2.86.44c5.25,0,9.74-4.73,10.85-6a22.69,22.69,0,0,0-3.63-3.31.5.5,0,0,1-.11-.69.5.5,0,0,1,.7-.12,22.32,22.32,0,0,1,4.08,3.81.48.48,0,0,1,0,.62C23.68,10.83,18.52,17.25,12,17.25Zm-7.53-2.8a.55.55,0,0,1-.3-.09,22.35,22.35,0,0,1-4.06-3.8.48.48,0,0,1,0-.62C.32,9.67,5.48,3.25,12,3.25a10.49,10.49,0,0,1,2.63.34.5.5,0,1,1-.25,1A9.37,9.37,0,0,0,12,4.25c-5.25,0-9.74,4.73-10.85,6a22.37,22.37,0,0,0,3.61,3.3.5.5,0,0,1,.11.69A.48.48,0,0,1,4.47,14.45ZM8,10.75a.5.5,0,0,1-.5-.5A4.51,4.51,0,0,1,12,5.75a.5.5,0,0,1,0,1,3.5,3.5,0,0,0-3.5,3.5A.5.5,0,0,1,8,10.75Zm4,4a.5.5,0,0,1,0-1,3.5,3.5,0,0,0,3.5-3.5.5.5,0,0,1,1,0A4.51,4.51,0,0,1,12,14.75ZM2.25,20.5a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7L21.4.15a.48.48,0,0,1,.7,0,.48.48,0,0,1,0,.7L2.6,20.35A.47.47,0,0,1,2.25,20.5Z"
})));

var SvgEyeHide = function SvgEyeHide(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 20.5",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyeHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-hide.e2bed235.svg";
export { ForwardRef as ReactComponent };